import { UserAccessStatus, UserPermission } from '@amzn/awscat-portfolio-assessment-types';
import { isEmail, isPhoneNumber } from 'class-validator';

import { constants } from '../../common/Localization';
import { format } from '../../common/util';
import { emailMaxLength } from './constants';

export function validateEmail(email: string): string {
    if (email.length > emailMaxLength) {
        return format(constants.EMAIL_TOO_LONG, [`${emailMaxLength}`]);
    } else if (!isEmail(email)) {
        return constants.EMAIL_NOT_CONFORM_TO_PATTERN;
    }
    return '';
}

/**
 * Returns an empty string if given string is a valid phone number
 * Returns an error string if given string is not a valid phone number
 * @param phone 
 * @returns string
 */
export function validatePhone(phone: string): string {
    if (!isPhoneNumber(phone, 'US')) {
        return constants.PHONE_NUMBER_INVALID;
    }
    return '';
}

export function currentStatus(userPermission: UserPermission) {
    if (userPermission.permissionKey) {
        return UserAccessStatus.INVITED;
    } else {
        return UserAccessStatus.EXISTING;
    }
}
